module.exports = __webpack_public_path__ + "static/Resume-BenjaminKauppi-074d5ffd41c5036f6aea2d0f6087b885.pdf";